<h2 mat-dialog-title data-test="dialog">{{ 'upload.title' | translate }}</h2>
<div mat-dialog-content>
  <button
    type="button"
    mat-stroked-button
    (click)="fileInput.click()"
    data-test="file-admission-file-button"
  >
    {{ selectedFile()?.name || ('upload.select-file-button-text' | translate) }}
  </button>
  <input
    hidden
    (change)="onAdmissionFileSelected($event)"
    #fileInput
    type="file"
    accept=".csv, .xls, .xlsx"
    data-test="file-input"
  />
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile()"
    (click)="onSubmit()"
    cdkFocusInitial
    data-test="dialog-submit"
    class="spacing--margin-right"
  >
    {{ 'upload.import-button-text' | translate }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ 'upload.cancel-button-text' | translate }}
  </button>
</div>
